import React from 'react';
import { AuthHeader } from '../../components/AuthHeader';
import './styles.css';

export const MainLayout = ({ children, onAuthViewChange }) => {

  return (
    <div className="main-wrap">
      <article className="main-content">
        <AuthHeader onAuthViewChange={onAuthViewChange} />

        <section className="page-content">
          {children}
        </section>

        <footer className="privacy-footer">
          By submitting, you agree to receive news from Childish Gambino and Sony Music.{' '}
          For more information on how we use your data, see this{' '}
          <a href="https://www.sonymusic.com/how-we-use-your-data/" target="_blank" rel="noopener noreferrer">
            link
          </a>
        </footer>
      </article>
    </div>
  );
};
